(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.constants')
		.constant('PATHS', {
			PHYSICAL: '/app/src/angular'
		})
		.constant('ROUTES', {
			APP: 'https://localhost:3000',
			APP_DEV: 'http://www-dev.expo-cupom-digital.com.br',
			API: '/api'
			// API: 'https://www-dev.expo-cupom-digital.com.br/api'
		})
		.constant('DATA_EVENTS', {
			DO_SEARCH: 'doSearch',
			OPEN_SEARCH: 'openSearch',
			CLOSE_SEARCH: 'closeSearch'
		})
		.constant('APP', {
			IDENTIFIER: 'ExpoDomPedro',
		})
}());